import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { UserService } from '../services/user.service';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

export const authGuard: CanActivateFn = (route, state) => {
	const userService = inject(UserService);
	const router = inject(Router);

	const token = localStorage.getItem('authToken');

	if (!token) {
		router.navigate(['/login']);
		return false;
	}

	// If user details are already loaded, allow access
	if (userService.userDetails()) {
		return true;
	}

	// Otherwise, fetch user info
	return userService.getUserInfo$().pipe(
		map((response) => {
			if (userService.userDetails()) {
				return true;
			} else {
				userService.clearUserDataAndRedirect();
				return false;
			}
		}),
		catchError((error) => {
			userService.clearUserDataAndRedirect();
			return of(false);
		})
	);
};
